import { productionConfig, stagingConfig } from "../constants";
// import { isValidPhoneNumber } from "react-phone-number-input";

export const getEnvConfig = () => {
  if (window.location.href.startsWith("https://staging.rainfall.one")) {
    return stagingConfig;
  } else if (window.location.href.startsWith("https://rainfall.one")) {
    return productionConfig;
  }
  return stagingConfig;
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

// export const validatePhoneNumber = (phoneNumber) => {
//   return isValidPhoneNumber(phoneNumber);
// };



export const scrollToElement = (element, headerOffset = 170) => {
  if (element) {
    const totalOffset =
      element.getBoundingClientRect().top + window.scrollY - headerOffset;

    if ("scrollBehavior" in document.documentElement.style) {
      window.scrollTo({
        top: totalOffset,
        behavior: "smooth",
      });
    } else {
      window.scrollTo(0, totalOffset);
    }
  }
};
